import { render, staticRenderFns } from "./yuceReport.vue?vue&type=template&id=cc5a486c"
import script from "./yuceReport.vue?vue&type=script&lang=js"
export * from "./yuceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports